export class SearchCaseRequest {
    userId: number;
    firstName: string;
    lastName: string;
    // dob: string;
    //phoneNumber: string;
    pageIndex: number;
    itemsCount: number;
    criteria: string;
    isClosedCases:boolean;
}
